import { render, staticRenderFns } from "./order-goods-info.vue?vue&type=template&id=29b89b30&scoped=true"
import script from "./order-goods-info.vue?vue&type=script&lang=js"
export * from "./order-goods-info.vue?vue&type=script&lang=js"
import style0 from "./order-goods-info.vue?vue&type=style&index=0&id=29b89b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b89b30",
  null
  
)

export default component.exports